<template>
  <v-dialog v-model="dialog" persistent max-height="500">
    <v-card>
      <v-img :src="data.image_url" contain max-height="210">
        <v-card-title
          class="align-start justify-end fill-height pa-0"
          primary-title
        >
          <v-btn x-small fab :color="color" class="ma-1"
            ><v-icon
              color="white"
              style="min-inline-size: -webkit-fill-available"
              @click="close"
              >mdi-window-close</v-icon
            >
          </v-btn>
        </v-card-title>
      </v-img>

      <v-card-text
        class="text-h6 text-start pt-5"
        style="text-align: center !important"
      >
        {{ data.name }}
      </v-card-text>
      <v-divider style="opacity: 1; color: black" class="mb-3 mx-3"></v-divider>
      <div class="mx-3">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          :color="color"
          fixed-tabs
        >
          <v-tab v-for="item in displayTypes" :key="item">
            {{ $t(item) }}
          </v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="item in displayTypes"
          :key="item"
          style="height: 250px"
        >
          <v-card color="basil" flat>
            <v-card-text v-if="item == 'code'" class="text-center">
              <v-container fluid>
                <v-row class="justify-center">
                  <v-col class="pa-0" cols="12"
                    >{{ $t("codeDiscount") }}
                  </v-col>
                  <v-col
                    class="pa-5 text-h6"
                    cols="12"
                    :style="{ color: color }"
                  >
                    <a
                      v-if="isLink"
                      :href="data.code"
                      target="_blank"
                      class="text-link"
                    >
                      {{ data.code }}
                    </a>

                    <p v-else>
                      {{ data.code }}
                    </p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-text
              v-if="item == 'barCode'"
              class="text-center"
              style="height: 200px"
            >
              <v-container fluid>
                <v-row class="justify-center" width="100%">
                  <v-col class="pa-0" cols="12">
                    <div width="100%">
                      <barcode :value="data.code" width="3">
                        {{ $t("errorQr") }}
                      </barcode>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-text
              v-if="item == 'qrCode'"
              class="text-center"
              style="height: 200px"
            >
              <v-spacer></v-spacer>
              <qrcode-vue :value="data.code" :size="size" level="H" />
              <v-spacer></v-spacer
            ></v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import VueBarcode from "vue-barcode";

export default {
  name: "CouponDialog",
  props: {
    dialog: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    displayTypes: { type: Array, default: () => ["code", "barCode", "qrCode"] },
    size: { type: Number, default: 150 },
    color: {
      type: String,
      default: "#000",
    },
  },
  components: {
    QrcodeVue,
    barcode: VueBarcode,
  },
  data() {
    return {
      tab: 0,
      copied: false,
    };
  },
  computed: {
    isLink() {
      if (!this.data || !this.data.code) return false;

      const regex =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

      return regex.test(this.data.code);
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.tab = 0;
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>